import { render } from "./BoqItemTableBreakdownReadOnly.vue?vue&type=template&id=3a23e19a&scoped=true"
import script from "./BoqItemTableBreakdownReadOnly.vue?vue&type=script&lang=js"
export * from "./BoqItemTableBreakdownReadOnly.vue?vue&type=script&lang=js"

import "./BoqItemTableBreakdownReadOnly.vue?vue&type=style&index=0&id=3a23e19a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a23e19a"]])

export default __exports__